<script setup lang="ts">
import type { AnnotationCollectionItem } from '@nuxt/content'

const route = useRoute('onderzoek-slug___nl')

const { data: sources } = useAsyncData(`investigation-${route.params.slug}-sources`, async () => {
  return queryCollection('annotation')
    .where('path', 'LIKE', `%${route.params.slug}%`)
    .all()
}, {
  default(): AnnotationCollectionItem[] {
    return []
  },
})

const sourcesSorted = useSorted(sources, (a, b) => Number.parseInt(a.title) - Number.parseInt(b.title))
</script>

<template>
  <section v-if="sources?.length" class="border-t border-t-neutral-200 bg-neutral-100 dark:border-t-neutral-600 dark:bg-neutral-900">
    <header class="border-b border-neutral-200 dark:border-neutral-600 py-4 mb-4">
      <UContainer>
        <h2 class="font-heading text-xl text-primary-800 dark:text-primary-200">
          Bronnen
        </h2>
      </UContainer>
    </header>
    <UContainer>
      <UPageColumns>
        <article
          v-for="source in sourcesSorted"
          :key="source.id"
          class="flex text-xs items-center"
        >
          <header class="w-6 text-right mr-2 flex-none truncate">
            <h3 class="border border-neutral-200 dark:border-neutral-700 text-neutral-500 dark:text-neutral-400 select-none rounded-full shrink-0 size-6 flex items-center justify-center">
              {{ source.title }}
            </h3>
          </header>

          <ContentRenderer
            :value="source"
            :prose="false"
            class="prose-a:underline prose-a:decoration-neutral-400 dark:prose-a:decoration-neutral-400 dark:hover:prose-a:decoration-neutral-300 prose-p:text-neutral-700 prose-a:text-neutral-800 dark:prose-p:text-neutral-300 dark:prose-a:text-neutral-100"
          />
        </article>
      </UPageColumns>
    </UContainer>
  </section>
</template>
